import { RecordStatus } from '../../types/menu/enums.types';
import { PermissionLevel, UserPermissionType } from '../../types/public/enum.types';

const moduleId = 29;
const featureId = 148;
const appId = 1;
export const momIngredientsPermissions = {
  'ingredients-visible': {
    permissionId: 5,
    appId,
    moduleId,
    featureId,
    key: 'ingredients-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'ingredients-create': {
    permissionId: 1,
    appId,
    moduleId,
    featureId,
    key: 'ingredients-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'ingredients-read': {
    permissionId: 4,
    appId,
    moduleId,
    featureId,
    key: 'ingredients-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'ingredients-edit': {
    permissionId: 2,
    appId,
    moduleId,
    featureId,
    key: 'ingredients-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'ingredients-delete': {
    permissionId: 3,
    appId,
    moduleId,
    featureId,
    key: 'ingredients-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};

export const defaultMomIngredientsPermissions = [
  momIngredientsPermissions['ingredients-visible'],
  momIngredientsPermissions['ingredients-create'],
  momIngredientsPermissions['ingredients-edit'],
  momIngredientsPermissions['ingredients-read'],
  momIngredientsPermissions['ingredients-delete'],
];
